import ModelUpdate from "@/models/ModelUpdate";
import {ValidationRule} from "@/declarations/ValidationRule";
import {EmploymentType, Gender} from "@/helpers/constants";
import User from "@/models/user/User";
import UserRules from "@/models/user/UserRules";

export default class UserUpdate extends ModelUpdate<User> {

	public companyId!: string;
	public firstname!: string;
	public lastname!: string;
	public gender!: Gender;
	public birthday!: string | null;
	public notes!: string | null;
	public countryCode!: string;
	public employmentType!: EmploymentType | null;
	public timeZone!: string;
	public languageCode!: string;

	protected initializeWithDetailModelData(detailModel: User): void {
		this.companyId = detailModel.company.id;
		this.firstname = detailModel.firstname;
		this.lastname = detailModel.lastname;
		this.gender = detailModel.gender;
		this.birthday = detailModel.birthday;
		this.notes = detailModel.notes;
		this.employmentType = detailModel.employmentType;
		this.countryCode = detailModel.countryCode;
		this.timeZone = detailModel.timeZone;
		this.languageCode = detailModel.languageCode;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'companyId':
				return UserRules.companyIdRules;
			case 'firstname':
				return UserRules.firstnameRules;
			case 'lastname':
				return UserRules.lastnameRules;
			case 'gender':
				return UserRules.genderRules;
			case 'birthday':
				return UserRules.birthdayRules;
			case 'notes':
				return UserRules.notesRules;
			case 'countryCode':
				return UserRules.countryCodeRules;
			case 'employmentType':
				return UserRules.employmentTypeRules;
			case 'timeZone':
				return UserRules.timeZoneRules;
			case 'languageCode':
				return UserRules.languageCodeRules;
			default:
				return [];
		}
	}

}
